<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="title">A NEW HISTORY OF THE KGB</h1>
<h1 class="titlea">The Birth of the Soviet Secret Police</h1>
<p class="titleb">Lenin and History’s Greatest Heist, 1917–1927</p>
<p class="author">Boris Volodarsky</p>
<div class="image_containerf">
<img alt="images" src="images/logo.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?fc68accc